<form [formGroup]="cbFormGroup">
    <div class="checkbox">
        <mat-checkbox formControlName="checkboxFormControl" class="d-block light-green-background-checkbox-rounded size-30" (change)="showChecked($event)">
            {{ 'claims.edit.review.reviewAndSubmit.checkbox' | translate }}
        </mat-checkbox>
    </div>
</form>